const initials = 'denomination/';
export const ADD_NEW_DENOMINATION = `${initials}ADD_NEW_DENOMINATION`;
export const REMOVE_AN_DENOMINATION = `${initials}REMOVE_AN_DENOMINATION`;
export const SET_NEW_DENOMINATION = `${initials}SET_NEW_DENOMINATION`;
export const UPDATE_QUANTITY_DENOMINATION = `${initials}UPDATE_QUANTITY_DENOMINATION`;
export const WIPE_OUT_DENOMINATION = `${initials}WIPE_OUT_DENOMINATION`;
